import React, { useState, useEffect, useMemo } from 'react';

import { StyledCaptionSpan } from '../buttons/Button.primary.styles';
import { LinkBrandedProps } from 'elements/links/Link.branded';
import { StyledLinkPro } from 'elements/links/Link.pro.styles';

import { propagateQuerytoExternalLinks, urlIsExternal, applyGanalyticsTracking } from 'src/functions/propagateQueryParams';
import { windowIsLoaded } from 'src/functions/windowIsLoaded';

const LinkPro = ({
  text,
  url,
  justify,
  caption,
  captionJustify,
  weight,
  sizeLg, sizeMd }: LinkBrandedProps): JSX.Element => {

  const [ queryPropagatedUrl, updateHref ] = useState(url)

  useEffect(() => {
    windowIsLoaded().then(() => {
      updateHref(propagateQuerytoExternalLinks(url));
    })
  }, [])

  const targetProp = useMemo(() => {
    return urlIsExternal(url) ? { target: '_blank', rel: 'noreferrer' } : {};
  }, [ url ])

  return (
    <StyledLinkPro
      justify={justify}
      weight={weight}
      sizeLg={sizeLg}
      sizeMd={sizeMd}
      onClick={applyGanalyticsTracking(queryPropagatedUrl, url)}
      href={queryPropagatedUrl || '#'}
      {...targetProp}
    >
      <span>
        {text}
      </span>
      {
        caption ?
          <StyledCaptionSpan captionJustify={captionJustify}>
            {caption}
          </StyledCaptionSpan>
          : null
      }
    </StyledLinkPro>
  )
}

export default LinkPro;
